// import http from './../../../base/api/public'
// let service = require('@/../config/serviceList')
// let sysConfig = require('@/../config/sysConfig')
// let apiPre = sysConfig.apiPre
// service.res = ''
// export default {
//   getCards (params) {
//     console.log('params:' + JSON.stringify(params))
//     return http.requestPost(apiPre + service.res + '/card/getList', params)
//   }
// }
// 导入基本公共资源
import http from './../../../base/api/public'

let sysConfig = require('@/../config/sysConfig')
let service = require('@/../config/serviceList')
// 定义访问网关的api,分为开发，测试，以及生产环境
let apiPre = sysConfig.apiPre
// 服务名
export default {
  stationsForSelectByOperatorId(params) {
    //console.log('params:' + JSON.stringify(params))
    return http.requestPost(apiPre + service.res + '/res/station/stationsForSelectByOperatorId', params)
  },
  operatorSelectionList() {
    return http.requestPost(apiPre + service.member + '/member/operator/listForSelect', {})
  },
  getOperatorsTree(params){
    return http.requestPost(apiPre + service.member + '/member/operator/listForSelectTree', params)
  },
  pilesForSelect(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPost(apiPre + service.res + '/res/pile/pilesForSelect', params)
  },
  gunListByPileId(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPost(apiPre + service.res + '/res/gun/getGunsByPileId', params)
  },
  listForSelectQuery(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPost(apiPre + service.res + '/res/brand/getBrands', params)
  },
  listForSelect(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPost(apiPre + service.res + '/res/model/getModels', params)
  }
}



// WEBPACK FOOTER //
// ./src/module/resourceCenter/api/commonApi.js